<template>
  <div class="profile">
    <v-layout row wrap>
      <v-flex lg7 md8 sm10 xs10 class="center" style="max-width: 950px !important;">
        <v-container grid-list-md class="pa-2 container-width">
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg12 md12 sm12 xs12>
                  <img :src="userInfo.image_path" style="height: 75px; border-radius: 50%;" />
                  <br/><br/>
                  <h2>{{ userInfo.name ? userInfo.name : 'None' }}</h2>
                  <br/>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="text-align: left;">
                <v-flex lg6 md6 sm12 xs12>
                  <v-layout row wrap>
                    <v-flex lg12 md12 sm12 xs12>
                      Legal Name: <b>{{ userInfo.name ? userInfo.name : 'None' }}</b>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex lg5 md5 sm12 xs12>
                  <v-layout row wrap>
                    <v-flex lg12 md12 sm12 xs12>
                      CC Email/s: <span class="wrap"><b>{{ userInfo.iso_emails && userInfo.iso_emails.length > 0 ? userInfo.iso_emails.toString() : 'None' }}</b></span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              
              <br/><br/>
              <div class="tabset" style="text-align: left;">
                <!-- Tab 1 -->
                <input type="radio" name="tabset" id="tab1" aria-controls="contact-email" checked>
                <label for="tab1">Contact & Email</label>
                <!-- Tab 2 -->
                <input type="radio" name="tabset" id="tab2" aria-controls="login-credentials">
                <label for="tab2">Login Credentials</label>
                <!-- Tab 3 -->
                <input type="radio" name="tabset" id="tab3" aria-controls="bank-account">
                <label for="tab3">Bank Account</label>
                <!-- Tab 4 -->
                <input type="radio" name="tabset" id="tab4" aria-controls="address">
                <label for="tab4">Address</label>
                <!-- Tab 5 -->
                <input type="radio" name="tabset" id="tab5" aria-controls="phone">
                <label for="tab5">Phone</label>
                <div class="tab-panels">
                  <section id="contact-email" class="tab-panel">
                    <div class="card-class">
                      <v-card color="white" class="black--text elevation-0">
                        <v-container fluid grid-list-lg class="container-style" style="padding: 0px;">
                          <v-layout row wrap>
                            <v-flex lg6 md6 sm12 xs12>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Contact Person: <b>{{ userInfo.name }}</b>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Email: <b>{{ userInfo.email ? userInfo.email : 'None' }}</b>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Domain Email: <b>{{ userInfo.domain_email ? userInfo.domain_email : 'None' }}</b>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  CC Email: <b>{{ userInfo.iso_emails && userInfo.iso_emails.length > 0 ? userInfo.iso_emails.toString() : 'None' }}</b>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg5 md5 sm12 xs12>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Tax ID: <b>{{ userInfo.iso_tax_id ? formatTaxId(userInfo.iso_tax_id) : 'None' }}</b>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Team: <b>{{ team.name ? team.name : 'None' }}</b>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Commission Percent: <b>{{ userInfo.iso_commission_percent ? userInfo.iso_commission_percent : '0' }}%</b>
                                </v-flex>
                              </v-layout>
                              <!-- <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Zip: <b>{{ userInfo.iso_zip ? userInfo.iso_zip : 'N/A' }}</b>
                                </v-flex>
                              </v-layout> -->
                            </v-flex>
                            <v-flex lg1 md1 sm12 xs12>
                              <v-tooltip top>
                                <v-btn slot="activator" icon style="float: right; margin-top: 0px;" @click="openEditDialog()">
                                  <v-icon>edit</v-icon>
                                </v-btn>
                                <span>Edit</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </div>
                  </section>
                  <section id="login-credentials" class="tab-panel">
                    <div class="card-class">
                      <v-card color="white" class="black--text elevation-0">
                        <v-container fluid grid-list-lg class="container-style" style="padding: 0px;">
                          <v-layout row wrap>
                            <v-flex lg6 md6 sm12 xs12>
                              <v-layout row wrap style="margin: 0px;">
                                <v-flex lg12 md12 sm12 xs12>
                                  User Name: <b>{{ userInfo.email }}</b>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg5 md6 sm12 xs12>
                              <v-layout row wrap style="margin: 0px;">
                                <v-flex lg12 md12 sm12 xs12>
                                  Password: <b>************</b>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg1 md1 sm12 xs12>
                              <v-tooltip top>
                                <v-btn slot="activator" icon style="float: right; margin-top: 0px;" @click="openPasswordDialog()">
                                  <v-icon>edit</v-icon>
                                </v-btn>
                                <span>Reset</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </div>
                  </section>
                  <section id="bank-account" class="tab-panel">
                    <div class="card-class">
                      <v-card color="white" class="black--text elevation-0">
                        <v-container fluid grid-list-lg class="container-style" style="padding: 0px;">
                          <v-layout row wrap>
                            <v-flex lg6 md6 sm12 xs12>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Bank Name: <b>{{ iso_bank_account.iso_account_name ? iso_bank_account.iso_account_name : 'N/A' }}</b>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Account Number: <b>{{ iso_bank_account.iso_account_number ? iso_bank_account.iso_account_number : 'N/A' }}</b>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg5 md5 sm12 xs12>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Routing Number: <b>{{ iso_bank_account.iso_account_routing_number ? iso_bank_account.iso_account_routing_number : 'N/A' }}</b>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg1 md1 sm12 xs12>
                              <v-tooltip top>
                                <v-btn slot="activator" icon style="float: right; margin-top: 0px;" @click="openBankAccountDialog()">
                                  <v-icon>edit</v-icon>
                                </v-btn>
                                <span>Edit</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </div>
                  </section>
                  <section id="address" class="tab-panel">
                    <div class="card-class">
                      <v-card color="white" class="black--text elevation-0">
                        <v-container fluid grid-list-lg class="container-style" style="padding: 0px;">
                          <v-layout row wrap>
                            <v-flex lg6 md6 sm12 xs12>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Street: <b>{{ iso_address.iso_street ? iso_address.iso_street : 'N/A' }}</b>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  City: <b>{{ iso_address.iso_city ? iso_address.iso_city : 'N/A' }}</b>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg5 md5 sm12 xs12>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  State: <b>{{ iso_address.iso_state ? iso_address.iso_state : 'N/A' }}</b>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Zip: <b>{{ iso_address.iso_zip ? iso_address.iso_zip : 'N/A' }}</b>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg1 md1 sm12 xs12>
                              <v-tooltip top>
                                <v-btn slot="activator" icon style="float: right; margin-top: 0px;" @click="openAddressDialog()">
                                  <v-icon>edit</v-icon>
                                </v-btn>
                                <span>Edit</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </div>
                  </section>
                  <section id="phone" class="tab-panel">
                    <div class="card-class">
                      <v-card color="white" class="black--text elevation-0">
                        <v-container fluid grid-list-lg class="container-style" style="padding: 0px;">
                          <v-layout row wrap>
                            <v-flex lg6 md6 sm12 xs12>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Phone Number: <b>{{ iso_phones.iso_phone_number ? iso_phones.iso_phone_number : 'N/A' }}</b>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                  Phone Type: <b>{{ iso_phones.iso_phone_type ? iso_phones.iso_phone_type : 'N/A' }}</b>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex lg5 md5 sm12 xs12></v-flex>
                            <v-flex lg1 md1 sm12 xs12>
                              <v-tooltip top>
                                <v-btn slot="activator" icon style="float: right; margin-top: 0px;" @click="openPhoneDialog()">
                                  <v-icon>edit</v-icon>
                                </v-btn>
                                <span>Edit</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </div>
                  </section>
                </div>
              </div>
              <!-- TABS END -->
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>

    <v-dialog v-model="editDialog" persistent max-width="800px">
      <v-card>
        <v-toolbar card color="white" class="black--text">
          <v-spacer></v-spacer>
          <v-toolbar-title>Contact & Email</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat icon color="grey" @click="closeEditDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-form>
            <v-container>
              <v-layout row wrap>
                <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.name"
                    label="Contact Person"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="userInfo.domain_email"
                    label="Domain Email"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex lg12 md12 sm12 xs12>
                  <v-combobox
                    v-model="userInfo.iso_emails"
                    label="CC Emails"
                    autocomplete="off"
                    hint="Hit enter to add multiple"
                    persistent-hint
                    hide-selected
                    multiple
                    chips
                  ></v-combobox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="closeEditDialog()">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="submitContactInfo()">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ResetPassword
      v-if="passwordDialog"
      @closePasswordDialog="closePasswordDialog"
      :passwordDialog="passwordDialog"
    />

    <v-dialog v-model="addressDialog" persistent max-width="800px">
      <v-card>
        <v-toolbar card color="white" class="black--text">
          <v-spacer></v-spacer>
          <v-toolbar-title>Address</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat icon color="grey" @click="closeAddressDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-form>
            <v-container>
              <v-layout row wrap>
                <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="iso_address.iso_street"
                    label="Street"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="iso_address.iso_city"
                    label="City"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12>
                  <v-select
                    v-model="iso_address.iso_state"
                    :items="state"
                    color="blue darken-2"
                    label="State"
                    return-object
                    autocomplete
                    hide-details
                  ></v-select>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="iso_address.iso_zip"
                    label="Zip"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="closeAddressDialog()">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="updateIsoAddress()">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="phoneDialog" persistent max-width="600px">
      <v-card>
        <v-toolbar card color="white" class="black--text">
          <v-spacer></v-spacer>
          <v-toolbar-title>Phone</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat icon color="grey" @click="closePhoneDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-form>
            <v-container>
              <v-layout row wrap>
                <v-flex lg6 md6 sm12 xs12>
                  <v-text-field
                    v-model="iso_phones.iso_phone_number"
                    label="Phone Number"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12>
                   <v-autocomplete
                    v-model="iso_phones.iso_phone_type"
                    :rules="[v => !!v || 'Iso Phone Type is required']"
                    :items="iso_phone_type"
                    color="blue darken-2"
                    label="Iso Phone Type"
                    :disabled="disabled == 1 ? true : false"
                    persistent-hint
                    autocomplete
                    required
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="closePhoneDialog()">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="updateIsoPhone()">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="bankAccountDialog" persistent max-width="800px">
      <v-card>
        <v-toolbar card color="white" class="black--text">
          <v-spacer></v-spacer>
          <v-toolbar-title>Bank Account</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat icon color="grey" @click="closeBankAccountDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-0">
          <v-form>
            <v-container>
              <v-layout>
                <v-flex lg12 md12 sm12 xs12>
                  <v-text-field
                    v-model="iso_bank_account.iso_account_name"
                    label="Bank Name"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex lg12 md12 sm12 xs12>
                  <v-text-field
                    v-model="iso_bank_account.iso_account_number"
                    label="Account Number"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex lg12 md12 sm12 xs12>
                  <v-text-field
                    v-model="iso_bank_account.iso_account_routing_number"
                    label="Routing Number"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="closeBankAccountDialog()">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="updateIsoBankInfo()">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import ResetPassword from "./Dialogs/ResetPassword";
import {URL} from '../../env'

export default {
  components: {
    ResetPassword,
  },
  data() {
    return {
      state: [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansa",
        "Kentucky",
        "Lousiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ],
      editDialog: false,
      passwordDialog: false,
      bankAccountDialog: false,
      addressDialog: false,
      phoneDialog: false,
      iso_phone_type: ['Mobile', 'Home', 'Business', 'Fax'],
      rules: {
        min: (v) => v.length >= 8 || "Min 8 characters",
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      userInfo: {},
      iso_address: {},
      iso_phones: {},
      iso_bank_account: {},
      team: {},
    };
  },
  mounted() {
    this.getProfile();
  },

  methods: {
    formatTaxId(taxId) {
      // usa format ##-#######
      if (taxId.length === 9) {
        return `${taxId.slice(0, 2)}-${taxId.slice(2)}`;
      }
      return taxId; // return as is if not 9 digits
    },
    openEditDialog() {
      this.editDialog = true;
    },
    closeEditDialog() {
      this.editDialog = false;
    },

    openPasswordDialog() {
      this.passwordDialog = true;
    },
    closePasswordDialog() {
      this.passwordDialog = false;
    },

    openBankAccountDialog() {
      this.bankAccountDialog = true;
    },
    closeBankAccountDialog() {
      this.bankAccountDialog = false;
    },
    openAddressDialog() {
      this.addressDialog = true;
    },
    closeAddressDialog() {
      this.addressDialog = false;
    },

    openPhoneDialog() {
      this.phoneDialog = true;
    },
    closePhoneDialog() {
      this.phoneDialog = false;
    },

    async updateIsoAddress() {
      const isoId = localStorage.getItem("iso_id");
      if (this.iso_address.id) {
        await axios.patch(`${URL}/api/iso_address/iso_addresses/${this.iso_address.id}`, this.iso_address);
      } else {
        await axios.post(`${URL}/api/iso_address/iso_addresses`, { ...this.iso_address, iso_id: isoId });
      }
      this.closeAddressDialog();
      this.getProfile();
    },

    async updateIsoPhone() {
      const isoId = localStorage.getItem("iso_id");
      if (this.iso_phones.id) {
        await axios.patch(`${URL}/api/iso_phone/iso_phones/${this.iso_phones.id}`, this.iso_phones);
      } else {
        await axios.post(`${URL}/api/iso_phone/iso_phones`, { ...this.iso_phones, iso_id: isoId });
      }
      this.closePhoneDialog();
      this.getProfile();
    },

    async getProfile() {
      try {
        const isoId = localStorage.getItem("iso_id");
        const uniqueId = localStorage.getItem("unique_id");
        console.log("Fetching profile for ISO ID:", isoId, "Unique ID:", uniqueId);

        const [iso, iso_address, iso_phones, iso_bank_account] = await Promise.all([
          axios.get(`${URL}/api/iso/isos/${uniqueId}`),
          axios.get(`${URL}/api/iso_address/iso_addresses/${isoId}`),
          axios.get(`${URL}/api/iso_phone/iso_phones/${isoId}`),
          axios.get(`${URL}/api/iso_bank_account/iso_bank_accounts/${isoId}`),
        ]);

        const isoData = Array.isArray(iso.data) ? iso.data[0] : iso.data;
        if (!isoData) {
          console.error("getProfile: no user data returned", iso.data);
          return;
        }
        await axios.get(`${URL}/api/team/teams/${isoData.iso_team_id}`).then(res => {
          this.team = res.data.data;
        });
        this.userInfo = isoData;
        this.userInfo.iso_emails = this.userInfo.iso_emails ? JSON.parse(this.userInfo.iso_emails) : [];
        this.iso_address = iso_address.data.data && iso_address.data.data.length > 0 ? iso_address.data.data[0] : {};
        this.iso_phones = iso_phones.data.data && iso_phones.data.data.length > 0 ? iso_phones.data.data[0] : {};
        this.iso_bank_account = iso_bank_account.data.data && iso_bank_account.data.data.length > 0 ? iso_bank_account.data.data[0] : {};
      } catch (err) {
        console.error("getProfile error:", err);
      }
    },
    async submitContactInfo() {
      const payload = {
        ...this.userInfo,
        iso_emails: JSON.stringify(this.userInfo.iso_emails)
      };
      await axios.patch(`${URL}/api/iso/isos/${this.userInfo.id}`, payload);
      this.closeEditDialog();
      this.getProfile();
    },
    async updateIsoBankInfo() {
     if(this.iso_bank_account.id){
        await axios.patch(`${URL}/api/iso_bank_account/iso_bank_accounts/${this.iso_bank_account.id}`, this.iso_bank_account);
      }else{
        await axios.post(`${URL}/api/iso_bank_account/iso_bank_accounts`, this.iso_bank_account);
      }
      this.closeBankAccountDialog();
      this.getProfile();
    },
  },
};
</script>

<style scoped>
.container-width {
  max-width: 100% !important;
}

.profile {
  line-height: 1;
}

.container-style {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left;
}

.card-class {
  margin: 1px 0px;
}

.esign-email {
  word-wrap: break-word;
}

.wrap {
  word-wrap: break-word;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* TABS */
.tabset > input[type="radio"] {
  position: absolute;
  left: -200vw;
}

.tabset .tab-panel {
  display: none;
}

.tabset > input:first-child:checked ~ .tab-panels > .tab-panel:first-child,
.tabset > input:nth-child(3):checked ~ .tab-panels > .tab-panel:nth-child(2),
.tabset > input:nth-child(5):checked ~ .tab-panels > .tab-panel:nth-child(3),
.tabset > input:nth-child(7):checked ~ .tab-panels > .tab-panel:nth-child(4),
.tabset > input:nth-child(9):checked ~ .tab-panels > .tab-panel:nth-child(5),
.tabset > input:nth-child(11):checked ~ .tab-panels > .tab-panel:nth-child(6) {
  display: block;
}

.tabset > label {
  position: relative;
  display: inline-block;
  padding: 15px 15px 25px;
  border: 1px solid transparent;
  border-bottom: 0;
  cursor: pointer;
  font-weight: 600;
}

.tabset > label::after {
  content: "";
  position: absolute;
  left: 15px;
  bottom: 10px;
  width: calc(100% - 28px);
  height: 4px;
  background: #8d8d8d;
}

input:focus-visible + label {
  outline: 2px solid rgba(0,102,204,1);
  border-radius: 3px;
}

.tabset > label:hover,
.tabset > input:focus + label,
.tabset > input:checked + label {
  color: #06c;
}

.tabset > label:hover::after,
.tabset > input:focus + label::after,
.tabset > input:checked + label::after {
  background: #06c;
}

.tabset > input:checked + label {
  border-color: #ccc;
  border-bottom: 1px solid #fff;
  margin-bottom: -1px;
}

.tab-panel {
  padding-top: 10px;
  border-top: 1px solid #ccc;
}
/* TABS END */
</style>
